import { withJsonFormsControlProps } from "@jsonforms/react";
import "./PointsConversionPreview.scss";

const formatPoints = (value) => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return "- points";
  }

  return `${numericValue} ${numericValue === 1 ? "point" : "points"}`;
};

export const PointsConversionPreviewComponent = ({ data, visible }) => {
  if (visible === false) {
    return null;
  }

  return (
    <div className="points-conversion-preview">
      <div className="points-conversion-preview__title">Conversion Preview</div>
      <div className="points-conversion-preview__value">
        $ 1.00 &rarr; {formatPoints(data)}
      </div>
    </div>
  );
};

export const PointsConversionPreviewControl = withJsonFormsControlProps(
  PointsConversionPreviewComponent
);
